import { render, staticRenderFns } from "./NoteCenter.vue?vue&type=template&id=f1d59fa0&scoped=true&"
import script from "./NoteCenter.vue?vue&type=script&lang=js&"
export * from "./NoteCenter.vue?vue&type=script&lang=js&"
import style0 from "./NoteCenter.vue?vue&type=style&index=0&id=f1d59fa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d59fa0",
  null
  
)

export default component.exports